let currentSaasProjectId = 1;

const allSeoInfo = {
  1:{
    title:'STEM未来计划-赋予STEM课堂独特魅力-让学生预见未来',
    favicon:'https://stem.ooowin.com/favicon.ico',
    keywords:'青云在线，浙江青云，stem，steam，stem课程，steam课程，stem教育，STEMx，STEM+，STEM活动，stem科学课程，stem教案，STEM/STEAM课件，steam/stem案例',
    description:'STEM未来计划引进美国STEM教材，进行本土化STEM课程体系开发。并持续关注国内外最新stem资讯、stem课程、stem案例,为广大青少年科学创新爱好者、学校、机构、学生、教师提供一站式整体解决方案，帮助学校、机构实现零基础开课。'
  },
 
  2:{
    title:'STEM未来计划SAAS版',
    favicon:'https://stem.ooowin.com/favicon.ico',
    keywords:'stem未来计划SAAS版, 演示版关键字，Stem',
    description:'stem未来计划SAAS版描述信息'
  },
  3:{
    title:'STEM未来计划SAAS版',
    favicon:'https://stem.ooowin.com/favicon.ico',
    keywords:'stem未来计划SAAS版, 演示版关键字，Stem',
    description:'stem未来计划SAAS版描述信息'
  }

}

module.exports = {
  saasProjectId: currentSaasProjectId,
  getSiteSeo: function getSiteSeo(){
    return allSeoInfo[currentSaasProjectId]
  }
}